<template>
  <div>
    <ListSearchToobar v-bind="searchToobarData" @search="init" v-model="searchRquest" ref="topBar" />
    <el-table :data="tableData" ref="multipleTable" @row-dblclick="dblclickAction" :height="tableHeight" highlight-current-row style="width: 100%" v-loading="loading" v-dynamicLoading="{fn: getListData}" header-row-class-name="highlight-last" cell-class-name="gray-back">
      <el-table-column type="index" :label="$t('pos')" width="110"></el-table-column>
      <el-table-column prop="no" :label="$t('order-no')" show-overflow-tooltip width="146"></el-table-column>
      <el-table-column prop="buyer" :label="$t('buyer')" width="160" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="company" :label="$t('company')" width="160" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="payableAmount" :formatter="AmountFormat" :label="$t('amount')" show-overflow-tooltip width="120"></el-table-column>
      <el-table-column prop="userNumber" :label="$t('user_qty')" show-overflow-tooltip width="164"></el-table-column>
      <el-table-column prop="productName" :label="$t('product')" show-overflow-tooltip width="114"></el-table-column>
      <el-table-column prop="paymentdate" :label="$t('payment_date')" show-overflow-tooltip width="166"></el-table-column>
      <el-table-column prop="activedate" :label="$t('active_date')" :formatter="activedFormat" show-overflow-tooltip width="136"></el-table-column>
      <el-table-column prop="monthNumber" :label="$t('subscribe-mon')" show-overflow-tooltip width="142"></el-table-column>
      <el-table-column prop="deadline" :label="$t('expire_date')" :formatter="deadlineFormat" show-overflow-tooltip width="136"></el-table-column>
      <el-table-column prop="status" :label="$t('order_status')" width="146" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status === 10">{{ $t('submitted') }}</span>
          <span v-if="scope.row.status === 20">{{ $t('canceled') }}</span>
          <span v-if="scope.row.status === 30">{{ $t('completed') }}</span>
          <span v-if="scope.row.status === 40">{{ $t('apply_trial') }}</span>
          <span v-if="scope.row.status === 50">{{ $t('on_trial') }}</span>
          <span v-if="scope.row.status === 80">{{ $t('trial_reject') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="paymentStatus" :formatter="paymentFormat" :label="$t('status')" show-overflow-tooltip width="168"></el-table-column>
      <el-table-column>
      </el-table-column>
      <el-table-column prop="operation" :label="$t('operation')" width="140">
        <template slot-scope="scope">
          <el-tooltip :content="$t('revoke')" placement="top" effect="light">
            <span class="icon" v-show="scope.row.status === 10" @click="CancelAction(scope.row)"><i class="icon-color common-icon icon-close"></i></span>
            <!-- <span class="icon" @click="CancelAction(scope.row)"><i class="icon-color common-icon icon-close"></i></span> -->
          </el-tooltip>
          <el-tooltip :content="$t('pay')" placement="top" effect="light">
            <span class="icon" v-show="scope.row.status !== 20 && scope.row.paymentStatus !== 30" v-if="scope.row.type === 10 || scope.row.type === 20" @click="PayActionNew(scope.row)"><i class="icon-color common-icon icon-pay"></i></span>
          </el-tooltip>
          <!-- 购买产品订单的申请试用 -->
          <!-- <el-tooltip :content="$t('trial')" placement="top" effect="light">
            <span class="icon" v-show="scope.row.status === 10 && scope.row.type === 10" @click="TrialAction(scope.row)"><i class="icon-color el-icon-time" style="scale:1.3;display:flex;padding-top:3px;"></i></span>
          </el-tooltip> -->
          <el-tooltip :content="$t('subscribe')" placement="top" effect="light">
            <span class="icon" v-show="scope.row.status === 10" v-if="scope.row.type === 30" @click="SubscribeAction(scope.row)"><i class="icon-color common-icon icon-subscription"></i></span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <Footerbar ref="foot">
      <TotalNum v-bind="totalOptions" :totalData="totalNumber" ref="totalNum" slot="right" />
    </Footerbar>
    <el-dialog :visible.sync="dialogVisible" width="80%" custom-class="dialog-class" :close-on-click-modal="false" destroy-on-close>
      <div slot="title" class="dialog-title">
        {{ $t('order') }}-{{rowData.no}}
      </div>
      <formPage v-if="dialogVisible" @init="init" :CancelAction="CancelAction" @PayAction="PayAction" :rowData="rowData" :readonly="readonly" @dialogVisible='dialogVisibleVal' />
      <span slot="footer" class="dialog-footer">
        <el-button round type="primary" v-show="rowData.status === 10" @click="handlePayClick" style="width: 200px" size="mini">{{ $t('pay') }}</el-button>
        <el-button round type="default" v-show="rowData.status === 10" @click="handleRevokeClick" style="width: 200px" size="mini">{{ $t('revoke') }}</el-button>
        <!-- <el-button round type="default" @click="handleCancelClick" style="width: 200px" size="mini">{{ $t('cancel') }}</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="trialDialogVisible" width="80%" custom-class="dialog-class" :close-on-click-modal="false" destroy-on-close>
      <div slot="title" class="dialog-title">
        {{ $t('order') }}-{{rowData.no}}
      </div>
      <trialPage v-if="trialDialogVisible" @init="init" :CancelAction="CancelAction" @PayAction="PayAction" :rowData="rowData" :readonly="readonly" @dialogVisible='dialogVisibleVal' />
      <span slot="footer" class="dialog-footer">
        <el-button round type="primary" v-show="rowData.status === 40" @click="handleTrialPayClick" style="width: 200px" size="mini">{{ $t('pay') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TotalNum from '@/components/TotalNum';
import ListSearchToobar from '@/components/ListSearchToobar';
import Footerbar from '@/components/Footerbar';
import dynamicLoading from '@/directive/dynamicLoading/index.js';
import orderApi from '@/apis/order';
import formPage from './formPage';
import trialPage from './trialPage';
import dateUtil from 'iceqerp-common/date-util';

export default {
  data() {
    return {
      searchToobarData: {
        showBarRight: true,
        floatRight: true,
        formArray: [
          {
            label: this.$t('order-no'),
            type: 'input',
            model: 'orderNo'
          },
          {
            label: this.$t('buyer'),
            type: 'input',
            model: 'buyer'
          },
          {
            label: this.$t('cellphone'),
            type: 'input',
            model: 'phone'
          },
          {
            label: this.$t('status'),
            type: 'select',
            model: 'status',
            options: [
              {
                value: '10',
                label: this.$t('unpaid')
              },
              {
                value: '20',
                label: this.$t('paid')
              },
              {
                value: '30',
                label: this.$t('refunded')
              }
            ]
          }
        ],
        iconName: 'icon-order',
        componentName: this.$t('order_list')
      },

      loading: false,
      tableData: [],
      multipleTable: [],
      totalNumber: 0,
      tableHeight: 0,
      dialogVisible: false,
      searchRquest: {
        orderNo: '',
        buyer: '',
        phone: '',
        createdDate: '',
        beginCreatedTime: '',
        endCreatedTime: '',
        status: ''
      },
      rowData: {},
      listData: {},
      readonly: false,
      totalOptions: {
        flag: false,
        whiteTheme: true,
        type: 'Orders'
      },
      stripeKey: '',
      reqNo: {},
      trialDialogVisible: false
    };
  },

  watch: {
    $route(to, from) {
      if (to.name === 'OrderList') {
        this.init();
      }
    }
  },

  computed: {},

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.refeshHeight();
      this.pageIndex = 1;
      if (
        this.searchRquest.createdDate === '' ||
        this.searchRquest.createdDate === null
      ) {
        this.searchRquest.beginCreatedTime = '';
        this.searchRquest.endCreatedTime = '';
      } else {
        const beginCreatedTime = dateUtil.getUtcBeginEndTimeStringOfDay(
          this.searchRquest.createdDate
        );
        this.searchRquest.beginCreatedTime = beginCreatedTime.beginTime;
        this.searchRquest.endCreatedTime = beginCreatedTime.endTime;
      }
      const req = {
        filter: {
          ...this.searchRquest
        }
      };
      this.totalNumber = 0;
      const res = await orderApi.userInstOrderCount(req);
      this.totalNumber = res.totalNumber;
      this.tableData = [];
      this.getListData();
      this.getKey();
    },

    refeshHeight() {
      setTimeout(() => {
        const navBarHeight = 80;
        this.tableHeight =
          window.innerHeight -
          navBarHeight -
          this.$refs.topBar.$el.offsetHeight -
          this.$refs.foot.$el.offsetHeight -
          10;
      }, 100);
    },

    async getListData() {
      if (this.loading || this.tableData.length >= this.totalNumber) {
        return;
      }
      this.loading = true;
      const req = {
        filter: {
          ...this.searchRquest
        },
        pageIndex: this.pageIndex,
        pageSize: 50
      };
      const res = await orderApi.userInstOrderList(req);
      this.tableData.push.apply(this.tableData, res.list);
      this.pageIndex++;
      this.loading = false;
      this.$refs.multipleTable.setCurrentRow(this.$refs.multipleTable.data[0]);
    },

    dblclickAction(row) {
      this.dialogVisible = true;
      this.readonly = true;
      this.rowData = { ...row };
    },

    async CancelAction(data) {
      this.$confirm(
        '<div><div class="el-message-box__message"><p style="font-weight: bold;">' +
          this.$t('revoke') +
          '</p><p>' +
          this.$t('revoke_tip1') +
          '</p></div></div>',
        {
          confirmButtonText: this.$t('revoke'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: true,
          roundButton: true,
          customClass: 'delete-message',
          iconClass: 'el-icon-error',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true; // 开启按钮加载状态
              instance.confirmButtonText = this.$t('revoke') + '...';
              if (this.dialogVisible) {
                const req = {
                  id: this.rowData.no
                };
                this.reqNo = req;
              } else {
                const req = {
                  id: data.no
                };
                this.reqNo = req;
              }
              const _that = this;
              orderApi.cancelOrder(this.reqNo).then(res => {
                if (res.succeeded) {
                  _that.init();
                  this.$message({
                    message: this.$t('order_close'),
                    type: 'success',
                    duration: 5000
                  });
                  this.dialogVisible = false;
                } else if (res.reason === 1003) {
                  this.$message({
                    message: this.$t('status_not_match'),
                    type: 'error',
                    duration: 5000
                  });
                } else if (res.reason === 1002) {
                  this.$message({
                    message: this.$t('form_not_exist'),
                    type: 'error',
                    duration: 5000
                  });
                }
              }).catch(err => {
                console.log('purchaseCreate err:', err);
              }).finally(() => {
                instance.confirmButtonLoading = false; // 开启按钮加载状态
                instance.confirmButtonText = this.$t('revoke');
                done();
              });
            } else {
              done();
            }
          }
        }
      )
        .then(() => {})
        .catch(() => {});
    },

    async getKey() {
      const req = {};
      const res = await orderApi.getStripeKey(req);
      this.stripeKey = res.key;
    },

    async PayActionNew(row) {
      if (row.status === 40 || row.status === 50 || row.status === 80) {
        this.trialDialogVisible = true;
        this.rowData = { ...row };
      } else {
        this.PayAction(row);
      }
    },

    async PayAction(row) {
      if (this.dialogVisible) {
        const req = {
          no: this.rowData.no
        };
        this.reqNo = req;
      } else {
        const req = {
          no: row.no
        };
        this.reqNo = req;
      }
      const res = await orderApi.createSession(this.reqNo);
      if (res.id) {
        window.open(
          'pay.html?sessionId=' + res.id + '&stripeKey=' + this.stripeKey,
          '_blank'
        );
      } else {
        this.$message.error((res.error || {}).message);
      }
    },

    async handleTrialPayClick() {
      if (this.rowData.userNumber === 0 || this.rowData.userNumber === '' || this.rowData.monthNumber === 0 || this.rowData.monthNumber === '') {
        this.$message({
          message: this.$t('user_quantity_and_month_required'),
          type: 'error',
          duration: 5000
        });
        return;
      }
      console.log('this.rowData', this.rowData);
      const req = {
        no: this.rowData.no,
        productId: this.rowData.productId,
        userNumber: this.rowData.userNumber,
        monthNumber: this.rowData.monthNumber,
        currency: this.rowData.currency
      };
      this.reqNo = req;
      const res = await orderApi.createTrialSession(this.reqNo);
      if (res.id) {
        window.open(
          'pay.html?sessionId=' + res.id + '&stripeKey=' + this.stripeKey,
          '_blank'
        );
      } else {
        this.$message.error((res.error || {}).message);
      }
    },

    async SubscribeAction(row) {
      if (this.dialogVisible) {
        const req = {
          no: this.rowData.no
        };
        this.reqNo = req;
      } else {
        const req = {
          no: row.no
        };
        this.reqNo = req;
      }
      const res = await orderApi.createSubSession(this.reqNo);
      window.open(
        'pay.html?sessionId=' + res.id + '&stripeKey=' + this.stripeKey,
        '_blank'
      );
    },

    async TrialAction(row) {
      this.loading = true;
      const req = {
        id: row.no
      };
      const res = await orderApi.applyTrialOrder(req);
      if (res.succeeded) {
        this.$alert(this.$t('requesting_a_trial'), this.$t('tips'), {
          confirmButtonText: this.$t('confirm'),
          callback: action => {
            this.init();
          }
        });
      } else if (res.reason === 1002) {
        this.$message({
          message: this.$t('order_not_exist'),
          type: 'error',
          duration: 5000
        });
      } else if (res.reason === 1003) {
        this.$message({
          message: this.$t('status_not_match'),
          type: 'error',
          duration: 5000
        });
      } else if (res.reason === 1004) {
        this.$message({
          message: this.$t('trial_orders_have_been_requested'),
          type: 'error',
          duration: 5000
        });
      }
      this.loading = false;
    },

    dialogVisibleVal(val) {
      this.dialogVisible = val;
    },

    AmountFormat(row) {
      return row.payableAmount + ' ' + row.currency;
    },

    createdFormat(row) {
      if ('createdTime' in row) {
        return row.createdTime.split(' ')[0];
      }
    },

    activedFormat(row) {
      if ('activeDate' in row) {
        return row.activeDate.split(' ')[0];
      }
    },

    deadlineFormat(row) {
      if ('deadline' in row) {
        return row.deadline.split(' ')[0];
      }
    },

    paymentFormat(row) {
      if (row.paymentStatus === 0) {
        return ' ';
      } else if (row.paymentStatus === 10 && (row.status === 40 || row.status === 50 || row.status === 80)) {
        return ' ';
      } else if (row.paymentStatus === 10) {
        return this.$t('unpaid');
      } else if (row.paymentStatus === 20) {
        return this.$t('paid');
      } else if (row.paymentStatus === 30) {
        return this.$t('refunded');
      }
    },

    // handleCancelClick() {
    //   this.dialogVisible = false;
    // },

    handleRevokeClick() {
      this.CancelAction();
    },

    handlePayClick() {
      if (this.rowData.type === 10 || this.rowData.type === 20) {
        this.PayAction();
      } else {
        this.SubscribeAction();
      }
    }
  },

  directives: { dynamicLoading },

  components: {
    ListSearchToobar,
    Footerbar,
    TotalNum,
    formPage,
    trialPage
  }
};
</script>
<style scope lang="scss">
.dialog-class {
  // background: #f4f4f4 !important;
  .el-dialog__header {
    padding-top: 53px;
  }

  // .el-dialog__body {
  //   padding: 0;
  // }
}

.el-tooltip__popper {
  color: #000 !important;
  max-width: 50%;
  background: #FFF !important;
  border: 1px  solid #000 !important;
  line-height: 1 !important;
  margin-bottom: 0px !important;
}
.el-tooltip__popper .popper__arrow:after {
  border-top-color: #FFF !important;
}
</style>
